{
	"access": {
		"ability": {
			"admins_manage": "Manage admins"
		},
		"copy_user_id": "Copy user ID",
		"no_permissions": "No permissions",
		"permissions": "Permissions",
		"sign_in_method": "Sign-in method",
		"source": {
			"email_otp": "Email code",
			"invite_accept": "Invite",
			"magic_link": "Magic link",
			"oauth": "Social login",
			"passkey": "Passkey",
			"password": "Password",
			"password_reset": "Password reset"
		},
		"title": "Access",
		"user_id": "User ID"
	},
	"account": {
		"personal_data": {
			"name_max": "Name must be at most 100 characters.",
			"name_required": "Enter your name.",
			"title": "Personal data"
		},
		"update_success": "Profile updated successfully."
	},
	"nav": {
		"personal": "Personal data",
		"security": "Security"
	},
	"security": {
		"access": {
			"description": "Update the password used to sign in to your account.",
			"otp_hint": "We'll email you a code to authorize the password change.",
			"success": "Password updated successfully.",
			"totp_hint": "Enter the code from your authenticator app to change your password.",
			"two_factor": {
				"email_code_sent": "Verification code sent. Check your inbox.",
				"email_resend_code": "Resend code",
				"email_send_code": "Send code",
				"verify_label": "Verification code"
			},
			"use_current_password": "Use your current password instead",
			"use_email_code": "Don't have a password? Use an email code",
			"validation": {
				"current_required": "Please enter your current password.",
				"max": "Password must be at most 255 characters."
			}
		},
		"password": {
			"title": "Password"
		}
	},
	"settings": {
		"account_description": "Your personal data and sign-in password."
	},
	"title": "Profile"
}
